/* OUTLAWZ, Vorlage. Vanilla JS, kein Framework. Läuft auf der Startseite und auf den Produktseiten. */
(() => {
  'use strict';

  const rmq = matchMedia('(prefers-reduced-motion: reduce)');
  const reduced = () => rmq.matches;
  const body = document.body;
  const clamp = (v, lo, hi) => Math.min(hi, Math.max(lo, v));

  /* ---------- Bilder laden: data-src, Platzhalter bleibt bei Fehler ---------- */
  function loadImages() {
    document.querySelectorAll('[data-src]').forEach(el => {
      const src = el.getAttribute('data-src');
      const target = el.querySelector('.img');
      if (!src || !target) return;
      const im = new Image();
      im.onload = () => {
        target.style.backgroundImage = `url("${src}")`;
        el.classList.add('has-img');
      };
      im.onerror = () => { /* kein Bild da: der Platzhalter bleibt */ };
      im.src = src;
    });
  }

  /* ---------- Wörter splitten (einmal, beim Laden) ---------- */
  function splitWords() {
    document.querySelectorAll('.split').forEach(el => {
      const text = el.textContent.trim();
      const words = text.split(/\s+/);
      const sr = document.createElement('span');
      sr.className = 'sr-only';
      sr.textContent = text;
      const vis = document.createElement('span');
      vis.setAttribute('aria-hidden', 'true');
      words.forEach((w, i) => {
        const s = document.createElement('span');
        s.className = 'w';
        s.style.setProperty('--i', i);
        s.textContent = w;
        vis.appendChild(s);
        if (i < words.length - 1) {
          const sp = document.createElement('span');
          sp.className = 'ws';
          vis.appendChild(sp);
        }
      });
      el.textContent = '';
      el.appendChild(sr);
      el.appendChild(vis);
    });
  }

  /* ---------- Nav ---------- */
  const nav = document.getElementById('nav');
  const menuBtn = nav.querySelector('.menu-btn');
  const menu = document.getElementById('menu');
  const navAlwaysSolid = nav.classList.contains('scrolled') && body.classList.contains('page-pdp');
  let navScrolled = navAlwaysSolid;
  function updateNav() {
    if (navAlwaysSolid) return;
    const s = scrollY > 24;
    if (s !== navScrolled) { navScrolled = s; nav.classList.toggle('scrolled', s); }
  }
  function setMenu(open) {
    menuBtn.setAttribute('aria-expanded', String(open));
    menuBtn.setAttribute('aria-label', open ? (nav.dataset.menuClose || 'Menü schliessen') : (nav.dataset.menuOpen || 'Menü öffnen'));
    if (open) {
      menu.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('open')));
    } else {
      menu.classList.remove('open');
      const hide = () => { if (!menu.classList.contains('open')) menu.hidden = true; };
      if (reduced()) hide(); else setTimeout(hide, 400);
    }
  }
  menuBtn.addEventListener('click', () => setMenu(menuBtn.getAttribute('aria-expanded') !== 'true'));
  menu.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
  addEventListener('keydown', e => { if (e.key === 'Escape' && menuBtn.getAttribute('aria-expanded') === 'true') { setMenu(false); menuBtn.focus(); } });

  /* ---------- Aufklappmenüs: Shop, Kollektionen, Land, Sprache ---------- */
  const drops = [...nav.querySelectorAll('.nav-item, .util')];
  function syncNavOpen() { nav.classList.toggle('is-open', drops.some(d => d.classList.contains('open')) || searchOpen); }
  function closeDrops(except) {
    drops.forEach(d => { if (d !== except && d.classList.contains('open')) { d.classList.remove('open'); d.querySelector('button').setAttribute('aria-expanded', 'false'); } });
    syncNavOpen();
  }
  let hoverT = null;
  drops.forEach(d => {
    const btn = d.querySelector('button');
    const open = () => { closeDrops(d); d.classList.add('open'); btn.setAttribute('aria-expanded', 'true'); syncNavOpen(); };
    const close = () => { d.classList.remove('open'); btn.setAttribute('aria-expanded', 'false'); syncNavOpen(); };
    btn.addEventListener('click', () => d.classList.contains('open') ? close() : open());
    if (d.classList.contains('nav-item')) {
      d.addEventListener('mouseenter', () => { clearTimeout(hoverT); hoverT = setTimeout(open, 120); });
      d.addEventListener('mouseleave', () => { clearTimeout(hoverT); hoverT = setTimeout(close, 220); });
    }
    d.addEventListener('focusout', e => { if (!d.contains(e.relatedTarget)) close(); });
  });
  document.addEventListener('click', e => { if (!nav.contains(e.target)) { closeDrops(); if (searchOpen) setSearch(false); } });
  addEventListener('keydown', e => { if (e.key === 'Escape') { closeDrops(); if (searchOpen) { setSearch(false); searchBtn.focus(); } } });

  /* ---------- Suche: sucht in den vier Teilen ---------- */
  // Die vier Teile kommen als JSON aus der Kopfzeile (Sprache und Pfade stimmen dann immer)
  let CATALOG = [];
  try { CATALOG = JSON.parse(document.getElementById('catalog').textContent); } catch (err) { CATALOG = []; }
  const NONE = nav.dataset.searchNone || 'Nichts gefunden.';
  const search = document.getElementById('search');
  const searchBtn = nav.querySelector('.search-btn');
  const searchInput = document.getElementById('search-input');
  const searchList = search.querySelector('.search-results');
  let searchOpen = false;
  function renderSearch(q) {
    const s = q.trim().toLowerCase();
    const hits = s ? CATALOG.filter(p => (p.name + ' ' + p.type + ' ' + p.words).toLowerCase().includes(s)) : CATALOG;
    searchList.innerHTML = hits.length
      ? hits.map(p => `<li><a href="${p.url}"><span><span class="sr-name">${p.name}</span><span class="sr-type">${p.type}</span></span><span class="sr-price">${p.price}</span></a></li>`).join('')
      : '<li class="sr-none">' + NONE + '</li>';
  }
  function setSearch(open) {
    searchOpen = open;
    searchBtn.setAttribute('aria-expanded', String(open));
    if (open) {
      closeDrops();
      search.hidden = false;
      renderSearch(searchInput.value);
      requestAnimationFrame(() => requestAnimationFrame(() => { search.classList.add('open'); searchInput.focus(); }));
    } else {
      search.classList.remove('open');
      const hide = () => { if (!searchOpen) search.hidden = true; };
      if (reduced()) hide(); else setTimeout(hide, 350);
    }
    syncNavOpen();
  }
  searchBtn.addEventListener('click', () => setSearch(!searchOpen));
  search.querySelector('.search-close').addEventListener('click', () => { setSearch(false); searchBtn.focus(); });
  searchInput.addEventListener('input', () => renderSearch(searchInput.value));
  searchInput.addEventListener('keydown', e => {
    if (e.key === 'Escape') { setSearch(false); searchBtn.focus(); }
  });

  /* ---------- Hero: drei Bilder, weich überblendet (nur Startseite) ---------- */
  const hero = document.querySelector('.hero');
  let schedule = () => {};
  if (hero) {
    const slides = [...hero.querySelectorAll('.slide')];
    const dots = [...hero.querySelectorAll('.dot')];
    const counterN = hero.querySelector('.counter-n');
    const INTERVAL = 5500;
    let cur = 0, timer = null, hovering = false, heroVisible = true;

    function restartKb(slide) {
      slide.querySelectorAll('.img,.ph,.kicker,.sub,.w').forEach(el => {
        el.style.animation = 'none';
        void el.offsetWidth;
        el.style.animation = '';
      });
    }
    // Hoechstens eine Folie geht gleichzeitig ab, darum ein einziger Merker.
    let abgang = null, abgangTimer = null;
    const ABGANG_MS = 1800;   // etwas laenger als die Ueberblendung von 1,6 Sekunden

    function go(n) {
      const next = (n + slides.length) % slides.length;
      if (next === cur && slides[cur].classList.contains('is-active')) return;
      // Vorherigen Abgang sofort abschliessen, sonst haengen zwei deckende Folien
      clearTimeout(abgangTimer);
      if (abgang) abgang.classList.remove('is-leaving');
      abgang = slides[cur];
      abgang.classList.remove('is-active');
      abgang.classList.add('is-leaving');
      abgangTimer = setTimeout(function () {
        if (abgang) abgang.classList.remove('is-leaving');
        abgang = null;
      }, ABGANG_MS);
      dots[cur].removeAttribute('aria-current');
      cur = next;
      restartKb(slides[cur]);
      slides[cur].classList.add('is-active');
      dots[cur].setAttribute('aria-current', 'true');
      counterN.textContent = String(cur + 1).padStart(2, '0');
    }
    schedule = function () {
      clearTimeout(timer); timer = null;
      const paused = reduced() || hovering || !heroVisible || document.hidden;
      hero.classList.toggle('paused', hovering);
      hero.classList.toggle('static', reduced());
      if (paused) return;
      timer = setTimeout(() => { go(cur + 1); schedule(); }, INTERVAL);
    };
    dots.forEach((d, i) => d.addEventListener('click', () => { go(i); schedule(); }));
    // Pause nur auf der Bedienzeile, nicht auf dem ganzen Hero. Der Hero ist
    // bildschirmhoch, die Maus liegt fast immer irgendwo darueber. Wer den ganzen
    // Hero pausieren laesst, hat auf dem Desktop eine Diashow, die nie laeuft.
    // Tastaturnutzer pausieren weiter ueber focusin.
    const heroUi = hero.querySelector('.hero-ui');
    if (heroUi) {
      heroUi.addEventListener('mouseenter', () => { hovering = true; schedule(); });
      heroUi.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    }
    hero.addEventListener('focusin', () => { hovering = true; schedule(); });
    hero.addEventListener('focusout', e => { if (!hero.contains(e.relatedTarget)) { hovering = false; schedule(); } });
    hero.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { go(cur + 1); schedule(); e.preventDefault(); }
      if (e.key === 'ArrowLeft') { go(cur - 1); schedule(); e.preventDefault(); }
    });
    new IntersectionObserver(entries => {
      heroVisible = entries[0].isIntersecting;
      schedule();
    }, { threshold: 0.15 }).observe(hero);
  }

  /* ---------- Sichtbarkeit: Entrances und lebende Elemente ---------- */
  const revealIO = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (en.isIntersecting) {
        en.target.classList.add('in');
        setTimeout(() => en.target.classList.add('settled'), reduced() ? 0 : 1600);
        revealIO.unobserve(en.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  document.querySelectorAll('.reveal').forEach(el => revealIO.observe(el));

  const liveIO = new IntersectionObserver(entries => {
    entries.forEach(en => en.target.classList.toggle('in-view', en.isIntersecting));
  }, { rootMargin: '10% 0px 10% 0px' });
  document.querySelectorAll('.sec').forEach(el => liveIO.observe(el));

  /* ---------- Der Halte-Moment: "Halt gedrückt. Lass sie fallen." (nur Startseite) ---------- */
  const hold = document.querySelector('.hold');
  let finishHold = () => {};
  if (hold) {
    const drop = hold.querySelector('.drop');
    const holdBtn = hold.querySelector('.btn-hold');
    const readout = hold.querySelector('.hold-readout');
    const label = hold.querySelector('.hold-label');
    let p = 0, holding = false, holdRaf = null, lastT = 0, lastP = -1, done = false, lastRead = '', lastReadAt = 0;

    function writeP(now) {
      if (Math.abs(p - lastP) >= 0.004 || p === 0 || p === 1) {
        lastP = p;
        drop.style.setProperty('--p', p.toFixed(3));
        holdBtn.style.setProperty('--p', p.toFixed(3));
      }
      const txt = Math.round(p * 100) + '%';
      const edge = p === 0 || p === 1;
      if ((edge || now - lastReadAt > 100) && txt !== lastRead) { lastRead = txt; lastReadAt = now; readout.textContent = txt; }
    }
    finishHold = function () {
      if (done) return;
      done = true;
      p = 1; writeP(performance.now());
      hold.classList.add('done');
      holdBtn.classList.remove('holding');
      label.textContent = holdBtn.dataset.done || 'Gefallen.';
      readout.textContent = '100%';
      holdBtn.setAttribute('aria-pressed', 'true');
      setTimeout(() => hold.classList.add('hold-settled'), reduced() ? 0 : 1400);
    };
    function tick(now) {
      const dt = Math.min(100, now - (lastT || now));
      lastT = now;
      if (holding) p += dt / 1600; else p -= dt / 1100;
      p = clamp(p, 0, 1);
      writeP(now);
      if (p >= 1) { finishHold(); holdRaf = null; lastT = 0; return; }
      if (!holding && p <= 0) { holdRaf = null; lastT = 0; return; }
      holdRaf = requestAnimationFrame(tick);
    }
    function startHold(e) {
      if (done) return;
      if (e && e.button !== undefined && e.button !== 0) return;
      holding = true;
      holdBtn.classList.add('holding');
      if (holdRaf === null) { lastT = 0; holdRaf = requestAnimationFrame(tick); }
    }
    function endHold() {
      if (!holding) return;
      holding = false;
      holdBtn.classList.remove('holding');
      if (holdRaf === null && p > 0 && !done) { lastT = 0; holdRaf = requestAnimationFrame(tick); }
    }
    holdBtn.addEventListener('pointerdown', e => {
      try { holdBtn.setPointerCapture(e.pointerId); } catch (err) { /* ohne Capture geht es auch */ }
      startHold(e);
    });
    holdBtn.addEventListener('pointerup', endHold);
    holdBtn.addEventListener('pointercancel', endHold);
    holdBtn.addEventListener('lostpointercapture', endHold);
    holdBtn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) { e.preventDefault(); startHold(); } });
    holdBtn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); endHold(); } });
    holdBtn.addEventListener('blur', endHold);
    holdBtn.addEventListener('click', e => e.preventDefault());
  }

  /* ---------- Klappen: Fragen auf der Startseite, Details auf den Produktseiten ---------- */
  document.querySelectorAll('.faq-q').forEach(btn => {
    const item = btn.closest('.faq-item');
    if (btn.getAttribute('aria-expanded') === 'true') item.classList.add('open');
    btn.addEventListener('click', () => {
      const open = !item.classList.contains('open');
      item.classList.toggle('open', open);
      btn.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------- Geld formatieren wie der Shop ---------- */
  const moneyFormat = body.dataset.moneyFormat || 'CHF {{amount}}';
  function money(cents) {
    const v = cents / 100;
    return moneyFormat
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(v).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v.toFixed(2).replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, v.toFixed(2));
  }

  /* ---------- Warenkorb-Schublade (cart-drawer) ---------- */
  const drawer = document.getElementById('cart-drawer');
  const backdrop = document.querySelector('.drawer-backdrop');
  const cartCount = document.querySelector('.cart-count');
  function thumb(url) { return url ? url.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : ''; }
  function renderCart(cart) {
    if (!drawer) return;
    const list = drawer.querySelector('.drawer-items');
    const empty = drawer.querySelector('.drawer-empty');
    const count = drawer.querySelector('.drawer-count');
    list.innerHTML = cart.items.map(it => `<li class="drawer-item" data-key="${it.key}">
      <a class="drawer-media" href="${it.url}">${it.image ? `<div class="img" style="background-image:url('${thumb(it.image)}')"></div>` : '<div class="ph ph-sm"></div>'}</a>
      <div>
        <p class="drawer-name">${it.product_title.replace('Outlawz™ ', '')}</p>
        <p class="drawer-var">${it.variant_title || ''}</p>
        <div class="drawer-row">
          <span class="qty"><button type="button" data-qty="-1" aria-label="−">−</button><span>${it.quantity}</span><button type="button" data-qty="1" aria-label="+">+</button></span>
          <strong class="price">${money(it.final_line_price)}</strong>
        </div>
        <button class="drawer-remove" type="button" data-qty="0">${drawer.dataset.tRemove}</button>
      </div>
    </li>`).join('');
    empty.hidden = cart.item_count > 0;
    drawer.querySelector('.drawer-total').textContent = money(cart.total_price);
    drawer.querySelector('.drawer-checkout').classList.toggle('btn-disabled', cart.item_count === 0);
    count.hidden = cart.item_count === 0; count.textContent = cart.item_count;
    if (cartCount) { cartCount.hidden = cart.item_count === 0; cartCount.textContent = cart.item_count; }
  }
  async function fetchCart() { const r = await fetch((drawer ? drawer.dataset.urlCart : '/cart') + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function openDrawer() {
    if (!drawer) return;
    try { renderCart(await fetchCart()); } catch (err) { /* offline: Schublade trotzdem zeigen */ }
    drawer.hidden = false; backdrop.hidden = false; drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(() => requestAnimationFrame(() => { drawer.classList.add('open'); backdrop.classList.add('open'); body.classList.add('drawer-open'); }));
    const first = drawer.querySelector('[data-cart-close]'); if (first) first.focus();
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('open'); backdrop.classList.remove('open'); body.classList.remove('drawer-open'); drawer.setAttribute('aria-hidden', 'true');
    const hide = () => { if (!drawer.classList.contains('open')) { drawer.hidden = true; backdrop.hidden = true; } };
    if (reduced()) hide(); else setTimeout(hide, 450);
  }
  if (drawer) {
    document.querySelectorAll('[data-cart-open]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); openDrawer(); }));
    drawer.querySelectorAll('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
    backdrop.addEventListener('click', closeDrawer);
    addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
    drawer.addEventListener('click', async e => {
      const b = e.target.closest('[data-qty]'); if (!b) return;
      const item = b.closest('.drawer-item'); const key = item.dataset.key;
      const cur = parseInt(item.querySelector('.qty span').textContent, 10);
      const delta = parseInt(b.dataset.qty, 10);
      const quantity = delta === 0 ? 0 : Math.max(0, cur + delta);
      b.disabled = true;
      try {
        const r = await fetch(drawer.dataset.urlChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
        renderCart(await r.json());
      } catch (err) { b.disabled = false; }
    });
  }

  /* ---------- Produktseite: Option wählen, Variante setzen, in den Warenkorb ohne Neuladen ---------- */
  const pdpForm = document.getElementById('pdp-form');
  if (pdpForm) {
    let variants = [];
    try { variants = JSON.parse(document.getElementById('variants').textContent); } catch (err) { variants = []; }
    let knapp = {};
    try { knapp = JSON.parse(document.getElementById('knapp').textContent); } catch (err) { knapp = {}; }

    const idInput = pdpForm.querySelector('.pdp-variant-id');
    const cartBtn = pdpForm.querySelector('.btn-cart');
    const stickyBtn = document.querySelector('[data-sticky-add]');
    const sticky = document.querySelector('.sticky-buy');
    const addLabel = cartBtn.textContent.trim();
    const groups = [...pdpForm.querySelectorAll('.sizes-row, .swatches')];
    function selected() {
      return groups.map(g => { const b = g.querySelector('[aria-pressed="true"], [aria-current="true"]'); return b ? b.dataset.value : null; });
    }
    // Drop-Sperre: der Server haengt .drop-zu an den Knopf. Dann ruehrt das Skript weder
    // Zustand noch Beschriftung an. Ohne das macht die Wahl einer Groesse den gesperrten
    // Knopf wieder klickbar, und die Kauf-Leiste am Handy legt wirklich in den Warenkorb.
    const dropZu = cartBtn.classList.contains('drop-zu');
    function setButtons(available, label) {
      if (dropZu) return;
      [cartBtn, stickyBtn].forEach(b => { if (!b) return; b.disabled = !available; b.textContent = label; });
    }
    function applySelection() {
      const sel = selected();
      // Bei mehreren Optionen, etwa Groesse Hoodie und Groesse Joggers beim Set, darf eine noch
      // nicht getroffene Wahl nicht durchgehen. Sonst nimmt find() die erste Variante, bei der
      // die eine gewaehlte Option passt, und der Kunde kauft eine zweite Groesse, die er nie
      // angeklickt hat. Mit nur einer Option aendert sich nichts, dort ist beim Laden immer
      // eine Groesse vorgewaehlt.
      if (sel.some(val => val === null)) {
        setButtons(false, cartBtn.dataset.waehlen || addLabel);
        const zu = document.querySelector('.pdp-knapp');
        if (zu) zu.hidden = true;
        return;
      }
      const v = variants.find(x => sel.every((val, i) => x['option' + (i + 1)] === val));
      if (!v) { setButtons(false, cartBtn.dataset.soldOut || addLabel); return; }
      idInput.value = v.id;
      setButtons(v.available, v.available ? addLabel : (cartBtn.dataset.soldOut || addLabel));
      document.querySelectorAll('[data-price]').forEach(el => { el.textContent = money(v.price); });
      // Vergleichspreis nur zeigen, wenn er hoeher ist als der Preis
      document.querySelectorAll('[data-compare]').forEach(el => {
        const hoeher = v.compare_at_price && Number(v.compare_at_price) > Number(v.price);
        el.hidden = !hoeher;
        if (hoeher) el.textContent = money(v.compare_at_price);
      });
      // Knappheit: die Zahl steht am gewaehlten Groessenknopf, Shopify liefert sie
      // im Varianten-JSON nicht mit. Der Server setzt sie nur unter der Schwelle.
      const knappEl = document.querySelector('.pdp-knapp');
      if (knappEl) {
        // Die Zahl gehoert zur gewaehlten Kombination, nicht zu einem einzelnen Groessenknopf.
        // Beim Set hat Shopify sie bereits aus dem knapperen der zwei Bauteile gerechnet.
        const n = knapp[v.id] || null;
        if (n) {
          knappEl.textContent = (knappEl.dataset.vorlage || '').replace('__N__', n);
          knappEl.hidden = false;
        } else { knappEl.hidden = true; }
      }
      if (!dropZu) { cartBtn.classList.remove('nudge'); void cartBtn.offsetWidth; cartBtn.classList.add('nudge'); }
    }
    groups.forEach(g => g.querySelectorAll('button').forEach(b => b.addEventListener('click', () => {
      const attr = g.classList.contains('swatches') ? 'aria-current' : 'aria-pressed';
      g.querySelectorAll('button').forEach(x => x.setAttribute(attr, 'false'));
      b.setAttribute(attr, 'true');
      const label = g.previousElementSibling && g.previousElementSibling.querySelector('span');
      if (label && g.classList.contains('swatches')) label.textContent = b.dataset.value;
      applySelection();
    })));
    async function addToCart() {
      if (dropZu || cartBtn.disabled) return;
      const was = cartBtn.textContent;
      setButtons(false, '…');
      try {
        const r = await fetch((drawer ? drawer.dataset.urlAdd : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: idInput.value, quantity: 1 }) });
        if (!r.ok) throw new Error('add failed');
        setButtons(true, cartBtn.dataset.added || was);
        setTimeout(() => setButtons(true, addLabel), 1800);
        openDrawer();
      } catch (err) {
        setButtons(true, was);
        pdpForm.submit();   // Notweg: normales Formular
      }
    }
    pdpForm.addEventListener('submit', e => { e.preventDefault(); addToCart(); });
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);
    // Kauf-Leiste am Handy: erscheint, sobald der echte Button nach oben aus dem Bild ist
    if (sticky && cartBtn) {
      new IntersectionObserver(entries => {
        const show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        sticky.classList.toggle('show', show);
        sticky.setAttribute('aria-hidden', String(!show));
      }, { threshold: 0 }).observe(cartBtn);
    }
  }

  /* ---------- Sprache und Land: Shopify-Formular abschicken ---------- */
  const locForm = document.getElementById('localization-form');
  if (locForm) {
    locForm.querySelectorAll('[data-locale]').forEach(b => b.addEventListener('click', () => { locForm.querySelector('[name="locale_code"]').value = b.dataset.locale; locForm.submit(); }));
    locForm.querySelectorAll('[data-country]').forEach(b => b.addEventListener('click', () => { locForm.querySelector('[name="country_code"]').value = b.dataset.country; locForm.submit(); }));
    document.querySelectorAll('.menu-langs [data-locale]').forEach(b => b.addEventListener('click', () => { locForm.querySelector('[name="locale_code"]').value = b.dataset.locale; locForm.submit(); }));
  }

  /* ---------- Ankündigungsleiste: Höhe an die Kopfzeile melden ---------- */
  const announce = document.querySelector('.announce');
  if (announce) {
    body.classList.add('has-announce');
    // getBoundingClientRect statt offsetHeight: offsetHeight rundet auf ganze Pixel.
    // Das Laufband ist 37.2375px hoch, gemeldet wurden 37px, und die fehlenden
    // 0.24px liessen den Hero minimal ueber den Falz ragen. Am 19. Oktober 2026 gemessen.
    const setH = () => document.documentElement.style.setProperty('--announce-h', announce.getBoundingClientRect().height + 'px');
    setH(); addEventListener('resize', setH);

    // Die Navi klebt unter dem Band. Das Band scrollt weg, die Navi bleibt stehen,
    // und oberhalb klafft dann ein durchsichtiger Streifen in Bandhoehe, durch den
    // der Seiteninhalt wandert. Am 19. Oktober 2026 auf dem Handy gesehen: 37 Pixel.
    // Darum rueckt die Navi genau so weit nach oben, wie das Band schon weg ist.
    const navEl = document.querySelector('.nav');
    if (navEl) {
      let offen = false;
      const navSetzen = () => {
        offen = false;
        const h = announce.getBoundingClientRect().height + announce.offsetTop;
        navEl.style.top = Math.max(0, h - window.scrollY) + 'px';
      };
      addEventListener('scroll', () => {
        if (offen) return;
        offen = true;
        requestAnimationFrame(navSetzen);
      }, { passive: true });
      addEventListener('resize', navSetzen);
      navSetzen();
    }
  }

  /* ---------- Hero: auch bei reduzierter Bewegung weiterblaettern ---------- */
  // app.js haelt die Diashow an, sobald das Betriebssystem "Bewegung reduzieren"
  // meldet, und zeigt dann dauerhaft Folie 1. Gemeint ist aber nur: keine
  // Animation. Der Inhalt soll weiter wechseln, sonst sehen genau die Leute mit
  // dieser Einstellung zwei Drittel der Startseite nie. Darum hier ein eigener
  // Takt, der schlicht den naechsten Punkt anklickt, ohne Ueberblendung.
  {
    const heroEl = document.querySelector('.hero');
    const rmq2 = matchMedia('(prefers-reduced-motion: reduce)');
    let takt = null;
    const steuern = () => {
      clearInterval(takt); takt = null;
      if (!heroEl || !rmq2.matches) return;
      const punkte = [...heroEl.querySelectorAll('.dot')];
      if (punkte.length < 2) return;
      takt = setInterval(() => {
        if (document.hidden) return;
        const i = punkte.findIndex(p => p.getAttribute('aria-current') === 'true');
        punkte[(i + 1) % punkte.length].click();
      }, 7000);
    };
    steuern();
    if (rmq2.addEventListener) rmq2.addEventListener('change', steuern); else rmq2.addListener(steuern);
  }

  /* ---------- FAQ-Seite: Seitentext (h2 = Gruppe, h3 = Frage) in Klappen umbauen ---------- */
  const faqSource = document.querySelector('[data-faq-source]');
  if (faqSource) {
    const out = document.createElement('div');
    out.className = 'faq-built';
    let group = null, item = null, n = 0;
    const closeItem = () => { item = null; };
    [...faqSource.childNodes].forEach(node => {
      if (node.nodeType !== 1) return;
      const tag = node.tagName.toLowerCase();
      if (tag === 'h2') {
        closeItem();
        const h = document.createElement('h2'); h.className = 'h3 faq-group'; h.textContent = node.textContent;
        out.appendChild(h);
        group = document.createElement('div'); group.className = 'faq'; out.appendChild(group);
      } else if (tag === 'h3') {
        n += 1;
        if (!group) { group = document.createElement('div'); group.className = 'faq'; out.appendChild(group); }
        item = document.createElement('div'); item.className = 'faq-item';
        item.innerHTML = `<h3 class="faq-h"><button class="faq-q" type="button" aria-expanded="false" aria-controls="faqp-${n}" id="faqp-${n}-q"></button></h3><div class="faq-a" id="faqp-${n}" role="region" aria-labelledby="faqp-${n}-q"><div class="faq-inner"></div></div>`;
        const btn = item.querySelector('.faq-q');
        btn.textContent = node.textContent;
        const x = document.createElement('span'); x.className = 'faq-x'; x.setAttribute('aria-hidden', 'true'); btn.appendChild(x);
        btn.addEventListener('click', () => {
          const el = btn.closest('.faq-item');
          const open = !el.classList.contains('open');
          el.classList.toggle('open', open);
          btn.setAttribute('aria-expanded', String(open));
        });
        group.appendChild(item);
      } else if (item) {
        item.querySelector('.faq-inner').appendChild(node.cloneNode(true));
      } else {
        const lede = node.cloneNode(true); lede.classList.add('faq-lede'); out.appendChild(lede);
      }
    });
    faqSource.replaceWith(out);
    // Direkt zu einer Frage springen (#faqp-3) oder alles per Suche im Browser finden: Klappen bleiben lesbar, weil der Text im DOM steht
    const target = location.hash && out.querySelector(location.hash);
    if (target) { const it = target.closest('.faq-item'); if (it) { it.classList.add('open'); it.querySelector('.faq-q').setAttribute('aria-expanded', 'true'); } }
  }

  /* ---------- Richtlinien-Seite: Shopify nennt die Rückgabe-Richtlinie "Widerrufsrecht", wir nennen sie wie in der Fusszeile ---------- */
  const polTitle = document.querySelector('.shopify-policy__title h1');
  if (polTitle && location.pathname.indexOf('/policies/refund-policy') !== -1 && body.dataset.tReturns) polTitle.textContent = body.dataset.tReturns;

  /* ---------- Scroll und Resize, delta-gegated ---------- */
  let scrollRaf = null;
  function onScroll() {
    if (scrollRaf !== null) return;
    scrollRaf = requestAnimationFrame(() => {
      scrollRaf = null;
      updateNav();
    });
  }
  addEventListener('scroll', onScroll, { passive: true });

  /* ---------- Versteckter Tab: alles pausieren ---------- */
  document.addEventListener('visibilitychange', () => {
    body.classList.toggle('paused', document.hidden);
    schedule();
  });

  /* ---------- Reduzierte Bewegung, live in beide Richtungen ---------- */
  function applyMotionMode() {
    if (reduced()) {
      finishHold();
      if (hold) hold.classList.add('hold-settled');
      document.querySelectorAll('.reveal').forEach(el => { el.classList.add('in', 'settled'); revealIO.unobserve(el); });
    }
    schedule();
  }
  rmq.addEventListener('change', applyMotionMode);

  /* ---------- Start ---------- */
  splitWords();
  loadImages();
  updateNav();
  applyMotionMode();
})();
